<template>
  <product-upsells v-bind="forwarded">
    <template v-if="$feature.tempShowATCAboveFold" #prev="{ action }">
      <base-button
        :aria-label="$t.previous"
        :class="[
          carouselClasses.controls,
          brandClasses.carouselControls,
          brandClasses.carouselPrevious,
        ]"
        data-test-id="vf-carousel-arrow-left"
        @click.stop="action"
      >
        <vf-icon dir="left" name="chevron" size="md" />
      </base-button>
    </template>
    <template v-if="$feature.tempShowATCAboveFold" #next="{ action }">
      <base-button
        :aria-label="$t.next"
        :class="[
          carouselClasses.controls,
          brandClasses.carouselControls,
          brandClasses.carouselNext,
        ]"
        data-test-id="vf-carousel-arrow-right"
        @click.stop="action"
      >
        <vf-icon dir="right" name="chevron" size="md" />
      </base-button>
    </template>
  </product-upsells>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#commerce/components/product/upsells/Upsells.vue'
import ProductUpsells from '#commerce/components/product/upsells/Upsells.vue'

const props = defineProps<Props>()
const emit = defineEmits<Emits>()
const forwarded = useForwardPropsEmits(props, emit)

const { $feature } = useNuxtApp()
const { brandClasses } = useAppConfig().components.product.upsells
const { brandClasses: carouselClasses } = useAppConfig().components.vf.carousel

if ($feature.tempShowATCAboveFold) {
  brandClasses.carouselControls = '<lg:top-5 <lg:mt-2 <lg:mx-2 lg:bottom-0'
  brandClasses.carouselNext = 'right-0 <lg:top-1/2 <lg:transform <lg:-translate-y-1/2 <lg:justify-end lg:mb-1 lg:mr-1'
  brandClasses.carouselPrevious = '<lg:top-1/2 <lg:transform <lg:-translate-y-1/2 <lg:left-0 lg:mb-1 lg:mr-8 lg:right-0'
}
</script>
